import { render, staticRenderFns } from "./UserDetailsList.vue?vue&type=template&id=3ac45ae2&"
import script from "./UserDetailsList.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports